import axios, { AxiosResponse } from 'axios'
import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { Balance, BalancesQueryResponse } from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const BALANCE_URL = `${API_URL}/admin/balances`
const GET_BALANCES_URL = `${API_URL}/admin/balances`

const getBalances = (query: string): Promise<BalancesQueryResponse | WoosatTelecomResponse<Balance[]>> => {
  return axios
    .get(`${GET_BALANCES_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<Balance[]>>) => {
      return d.data
    })
}

const getBalanceById = async (id: ID): Promise<Balance> => {
  try {
    const { data } = await axios.get(`${BALANCE_URL}/${id}`)
    return data?.data?.balance
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
}

const createBalance = (balance: Balance): Promise<Balance | undefined> => {
  const formData = new FormData()
  Object.entries(balance).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, value.toString())
    }
  })

  return axios
    .post(BALANCE_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<Balance>) => response.data)
}

const updateBalance = (balance: Balance): Promise<Balance | undefined> => {
  const newFormData = new FormData()
  Object.entries(balance).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      newFormData.append(key, value.toString())
    }
  })

  return axios
    .post(`${BALANCE_URL}/${balance.id}`, newFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => {
      if (response.data.success === true) {
        toast.success(response.data.message, { position: 'top-right' })
      } else {
        toast.error(response?.data?.message, { position: 'top-right' })
      }
      return response.data
    })
    .then((response: Response<Balance>) => response.data)
}

const deleteBalance = (balanceId: ID): Promise<void> => {
  return axios.delete(`${BALANCE_URL}/${balanceId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}

export const rollbackBalance = (balanceId: ID): Promise<void> => {
  return axios.post(`${BALANCE_URL}/rollback/${balanceId}`).then((response) => {
    if (response.data.success === true) {
      toast.success(response?.data?.message, { position: 'top-right' })
    } else {
      toast.error(response?.data?.message, { position: 'top-right' })
    }
  })
}


const deleteSelectedBalances = (balanceIds: Array<ID>): Promise<void> => {
  const requests = balanceIds.map((id) => axios.delete(`${BALANCE_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getBalances,
  deleteBalance,
  deleteSelectedBalances,
  getBalanceById,
  createBalance,
  updateBalance,
}
